<template>
  <div class="content">  
    <q-table
      :title="$t('global.EventJournal')"
      :data="itemsEvent"
      :columns="columnsEvent"
      row-key="IdEvent"
      :dense=true
      selection="single"
      :selected.sync="selectedRowsEvent"
      :loading="loading"
      :rows-per-page-options="[1,2,5,10,20,50,0]"
      :pagination.sync="pagination" 
      >

      <q-td slot="body-cell-Thumbnail" slot-scope="props" :props="props">
        <img :src="'data:image/png;base64,' + props.value" @click="showPic(props.row.IdEvent)">
      </q-td>

    <template slot="top-selection" slot-scope="props" >
      <div class="q-table-title">{{$t('global.EventJournal')}}</div>
      <div>
        <q-btn color="secondary" flat :label="$t('global.Map')" class="q-mr-sm" @click="showOnMap(selectedRowsEvent[0])" />  
        <q-btn color="secondary" flat :label="$t('global.FullScreen')" class="q-mr-sm" @click="showPic(selectedRowsEvent[0].IdEvent)" />  
         <q-btn color="secondary" flat :label="$t('global.Edit')" @click="editEvent()" />
        <q-btn color="secondary" flat :label="$t('global.Delete')" @click="deleteEvent()" />
      </div>
    </template>
    </q-table>

  <q-modal v-model="opened" maximized>
    <div style="padding: 10px">
      <q-btn color="primary" @click="opened = false" :label="$t('global.Close')" />
      <p></p>
      <div class="row">
        <div class="col-12">
          <img class="responsive" :src="bigPic">
        </div>
      </div>
      
    </div>
  </q-modal>
  </div>

</template>

<script>
import { date } from 'quasar'
import axios from 'axios'
import qs from 'qs'

import {eventBus} from '../../main'
export default {
  name: 'EventJournal',
  props: ['dateFrom', 'dateTo'],
  data: function () {
    return { 
      form: {
        SessionId: null,
      },
      opened: false,
      bigPic: null,
      picCache: [],
      pagination: {
        sortBy: null, // String, column "name" property value
        descending: false,
        page: 1,
        rowsPerPage: 1 // current rows per page being displayed
      },
      loading: false,
      selectedRowsEvent: [],  
      itemsEvent:[],
      columnsEvent: [
      {
        name: 'Created',required: true, label: this.$t('global.DateTime'),align: 'left',
        field: 'Created',sortable: true,
        format: val => this.dateFormat(val)
      },
      {
        name: 'Thumbnail',required: true,label: this.$t('global.Picture'),align: 'left',
        field: 'Thumbnail',sortable: false
      },
      {
        name: 'Comment',required: true,label: this.$t('global.Comment'),align: 'left',
        field: 'Comment',sortable: true
      },
      {
        name: 'QrCode',required: true,label: this.$t('global.QrScan'),align: 'left',
        field: 'QrCode',sortable: true
      },
      {
        name: 'TypeDescription',required: true,label: this.$t('global.EventType'),align: 'left',
        field: 'TypeDescription',sortable: true
      }
      ],
      columnHeaders: ['global.DateTime','global.Picture','global.Comment','global.QrScan','global.EventType'],
    }     
  },
  methods: {
    showOnMap (val) {
      if(this.$store.getters.getMapLoaded == true){
        this.showOnMapNext (val)
      }
      else{
        this.$router.push({name: 'Map'});
        self = this
        setTimeout(function() { window.dispatchEvent(self.showOnMapNext (val)) }, 500);
      }
    },
    showOnMapNext (val) {
      var pl = val.Position.substr(7, val.Position.length - 8)
      var gpl = pl.split(' ')
      var Lat = Number(gpl[1])
      var Lng = Number(gpl[0])
      var marker = new L.Marker([Lat, Lng])
      var popUp = '<div>Event Report</div>' +
      '<div>' + val.TypeDescription + '</div>' +
      '<div>' + val.Comment + '</div>' +
      '<div>' + val.UserName + '</div>' +
      '<div><img src="data:image/png;base64,' + val.Thumbnail + '"></div>'
      marker.bindPopup(popUp)
      eventBus.$emit('showObject', marker)   
      eventBus.$emit('centerMap', [Lat,Lng])    
      this.$router.push({name: 'Map'});
    },

    deleteEvent () {
      var self = this
      this.$q.dialog({
        title: this.$t('global.DeleteEntry'),
        message: this.$t('global.DeleteEntryQuestion'),
        color: 'primary',
        ok: true, // takes i18n value, or String for "OK" button label
        cancel: true, // takes i18n value, or String for "Cancel" button label
        preventClose: true,
        noBackdropDismiss: false, // gets set to "true" automatically if preventClose is "true"
        noEscDismiss: false, // gets set to "true" automatically if preventClose is "true"
        stackButtons: false,
        position: 'top',        
      })
      .then(() => {
       
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "userDeleteEvent"
      this.form.IdEvent = this.selectedRowsEvent[0].IdEvent
    
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              if(response.data == "OK"){
                self.selectedRowsEvent = []
                this.loadData()
                this.$q.notify({ message: 'Gelöscht', type: 'positive' })
              }
              else{
                this.$q.notify('Something Wrong.')
              }
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
      })
      .catch(() => {
        //alert('Picked cancel')
      })
    },
    loadData(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "getEventByUser"
      this.form.dateFrom = this.dateFrom
      this.form.dateTo = this.dateTo
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              this.itemsEvent = response.data
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },
    dateFormat(val) {
      if(val == null){
        return null
      }
      return this.moment(val).format(this.$store.state.session.DateTimeFormat)
    },
    showPic(IdEvent){
      if(this.picCache[IdEvent] == undefined){
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "getUserPic"
        this.form.IdEvent = IdEvent
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            this.submitting = false
            if(response.status == 200){ 
                this.bigPic = 'data:image/png;base64,' + response.data
                this.opened = true
                this.picCache[IdEvent] = this.bigPic

            }
            else{
                this.$q.notify('Something Wrong.')
            }
        })
        .catch(e => {
          this.$q.notify('Something Wrong.')
          console.log(e);
        })
      }
      else{
        this.bigPic = this.picCache[IdEvent]
        this.opened = true
      }
    },
    editEvent () {
      eventBus.$emit('editEvent', { IdEvent: this.selectedRowsEvent[0].IdEvent, process: false })
      //alert('edit now: ' + this.selectedRowsEvent[0].IdEvent)
    },
  },
  computed:{
    
  },
  mounted() {
     this.loadData() 
  },
  created () {
    eventBus.$on('addEvent', (data) => {
      this.loadData()
    }),
    eventBus.$on('Bus_ChangeLocale', (data) => {
      var cnr = 0
      this.columnHeaders.forEach(col => {
      this.columnsEvent[cnr].label = this.$t(col)
      cnr++
      })
    })
  },
  watch: {
    dateFrom: function (val) {
      this.loadData()
    },
    dateTo: function (val) {
      this.loadData()
    },
  },
  beforeDestroy(){
    
  }
}
</script>
<style scoped>
.content{
  padding: 10px;
}
.responsive {
  width: 100%;
  height: auto;
}
</style>
